import StoreButtons from './StoreButtons';

export default StoreButtons;
